import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import {
    SaveButton,
    SimpleForm,
    TextInput,
    Toolbar,
    useNotify,
    useRefresh,
} from 'react-admin';
import dataProvider from '../dataProvider';
import { UniqueRequest } from '../models/unique-request';

const SimpleToolbar = () => {
    return (
        <Toolbar>
            <SaveButton label="Mentés" />
        </Toolbar>
    );
};

export const UniqueRequestAdminDialog = ({
    record,
    open,
    setOpen,
}: {
    record: UniqueRequest;
    open: boolean;
    setOpen: any;
}) => {
    const notify = useNotify();
    const refresh = useRefresh();

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
            <SimpleForm
                toolbar={<SimpleToolbar />}
                onSubmit={async (values) => {
                    await dataProvider
                        .update('unique-request', {
                            id: record.id,
                            data: {
                                insideNote: values.insideNote,
                            },
                        })
                        .then(() => {
                            notify('Sikeres módosítás', { type: 'success' });
                            refresh();
                            setOpen(false);
                        });
                }}
            >
                <TextInput
                    source={'insideNote'}
                    label={'Admin megjegyzés'}
                    name={'insideNote'}
                    fullWidth
                />
            </SimpleForm>
        </Dialog>
    );
};
